<div class="container">
    <div class="content-wrapper">
        <h1>{{ "Come Say Hi" | translate }}</h1>
        <h3>

            {{ "We’re spread across the island so you’re never too far" | translate }} <br />
            {{ "from one of our friendly teams." | translate }}
        </h3>
        <div class="locations" *ngIf="shouldShowLocations">
            <div class="l-title">{{ "Visit us at" | translate }}</div>
            <div class="l-list">
                <div
                    class="l-content"
                    (click)="openInGoogleMaps('Trianon')"
                    (mouseenter)="highlightMarker('Trianon')"
                    (mouseleave)="resetMarker('Trianon')"
                >
                    <img src="assets/img/ICONS/location-icon.png" />
                    <div class="l-name">Trianon</div>
                </div>

                <div
                    class="l-content"
                    (click)="openInGoogleMaps('Head Office')"
                    (mouseenter)="highlightMarker('Head Office')"
                    (mouseleave)="resetMarker('Head Office')"
                >
                    <img src="assets/img/ICONS/location-icon.png" />
                    <div class="l-name">{{ "Head Office" | translate }}</div>
                </div>

                <div
                    class="l-content"
                    (click)="openInGoogleMaps('Ruisseau Créole')"
                    (mouseenter)="highlightMarker('Ruisseau Créole')"
                    (mouseleave)="resetMarker('Ruisseau Créole')"
                >
                    <img src="assets/img/ICONS/location-icon.png" />
                    <div class="l-name">Ruisseau Creole</div>
                </div>
            </div>
        </div>
    </div>
    <div class="m-container">
        <div id="agencies-map"></div>
    </div>
</div>
